import { render, staticRenderFns } from "./RuleGroupDetail.vue?vue&type=template&id=1dd8f0a1&scoped=true&"
import script from "./RuleGroupDetail.vue?vue&type=script&lang=js&"
export * from "./RuleGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8f0a1",
  null
  
)

export default component.exports